import { render, staticRenderFns } from "./manageDepartments.vue?vue&type=template&id=17b43c4a"
import script from "./manageDepartments.vue?vue&type=script&lang=ts"
export * from "./manageDepartments.vue?vue&type=script&lang=ts"
import style0 from "./manageDepartments.vue?vue&type=style&index=0&id=17b43c4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports